export const POS_ORDER_LOADING = 'POS_ORDER_LOADING';
export const POS_ORDERS_FULFILLED = 'POS_ORDERS_FULFILLED';
export const POS_ORDER_FULFILLED = 'POS_ORDER_FULFILLED';
export const POS_ORDER_STATUS_CHANGED = 'POS_ORDER_STATUS_CHANGED';
